module.exports = __webpack_public_path__ + "img/public/SiteIcons/documentRemove.svg?7a1ca299";